import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const state = () => ({
  uid: null,
  currentNoteId: null,
  selectedUserTopTab: "notes", // notes or testMode
});

export const getters = {
  uid: (state) => {
    return state.uid;
  },
  currentNoteId: (state) => {
    return state.currentNoteId;
  },
  selectedUserTopTab: (state) => {
    return state.selectedUserTopTab;
  },
};

export const mutations = {
  setUid(state, uid) {
    state.uid = uid;
  },
  setCurrentNoteId(state, noteId) {
    state.currentNoteId = noteId;
  },
  setSelectedUserTopTab(state, tabName) {
    state.selectedUserTopTab = tabName;
  },
};

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  plugins: [
    createPersistedState({
      key: "english-word",
      storage: localStorage,
    }),
  ],
});

export default store;
